export const businessIntelligence = {
  conformity_heatmap: {
    title: "Conformity Heatmap",
    description: "Interactive heatmap showing aggregated conformity levels across all sites and themes",
    loading_error: "Failed to load conformity data. Please try again.",
    stats: {
      total_tasks: "Total Tasks",
      sites_with_data: "Sites with Data",
      themes_with_data: "Themes with Data",
    },
    filters: {
      title: "Filters",
      year: "Year",
      all_years: "All Years",
      site: "Site",
      all_sites: "All Sites",
      theme: "Theme",
      all_themes: "All Themes",
      standard: "Standard",
      all_standards: "All Standards",
      assessment: "Assessment",
      all_assessments: "All Assessments",
      clear_all: "Clear all",
    },
    legend: {
      does_not_meet: "Does Not Meet",
      partially_meets: "Partially Meets",
      substantially_meets: "Substantially Meets",
      fully_meets: "Fully Meets",
      no_scorable_data: "No Scorable Data",
    },
    axis_labels: {
      sites: "Sites",
      themes: "Themes",
    },
    avg_conformity_level: "Avg. conformity level",
    no_data_message: "No data available for the selected filters. Try adjusting your filter criteria.",
  },
};
